module.exports = __webpack_public_path__ + "img/1493002964.efb62463.jpg";